export const ALLOWED_SPORTS = ['Pickleball', 'Tennis', 'Volleyball', 'Basketball', 'Badminton', 'Padel'];

export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
